export const DEFAULT_ANIMATION_INTERVAL = 15;
export const MIN_ANIMATION_DELAY = 2000;
export const RANDOM_ANIMATION_INTERVAL = 12000;
